export interface ItemConfig {
  id: string;
  name: string;
  imageUrl: string;
  description?: string;
  dialog?:string;
}

// Master list of all items in the game
export const itemsConfig: ItemConfig[] = [
  {
    id: 'teddy_bear',
    name: 'Boneka Beruang',
    imageUrl: 'assets/items/item_boneka.png',
    description: 'Boneka yang ditemukan di tanah. Bisa diberikan untuk kado Diana.',
    dialog : "Yan mendapatkan boneka beruang!"
  },
  {
    id: 'coin_gold',
    name: 'Uang',
    imageUrl: 'assets/items/item_uang.png',
    description: 'Uang yang bisa dibelanjakan',
  },
  {
    id: 'cap_tikus',
    name: 'Cap Tikus',
    imageUrl: 'assets/items/item_drink2.png',
    description: 'Cap Tikus, minimuan beralkohol khas lokal.',
  },
  {
    id: 'bible',
    name: 'Alkitab',
    imageUrl: 'assets/items/item_bible.png',
    description: 'Alkitab yang diberikan oleh Romo. Bisa jadi alternatif untuk kado Diana.',
  },
  {
    id: 'panada',
    name: 'Panada',
    imageUrl: 'assets/items/item_panada.png',
    description: 'Panada buatan nenek.',
  },
  {
    id: 'fish',
    name: 'Ikan',
    imageUrl: 'assets/items/item_ikan.png',
    description: 'Ikan Cakalang hasil tangkapan dari danau. Disukai oleh bapak-bapak.',
  },
  {
    id: 'liontin',
    name: 'Liontin',
    imageUrl: 'assets/items/item_liontin.png',
    description: 'Liontin misterius hasil pancingan dari danau.',
  },
  {
    id: 'sendal',
    name: 'Sendal',
    imageUrl: 'assets/items/item_sendal.png',
    description: 'Sandal hasil pancingan dari danau. Tidak Berguna',
  },
];

// Helper function to get item config by ID
export function getItemConfig(itemId: string): ItemConfig | undefined {
  return itemsConfig.find(item => item.id === itemId);
}

// Helper function to validate if an item ID exists
export function isValidItemId(itemId: string): boolean {
  return itemsConfig.some(item => item.id === itemId);
}
